/**
 * Firebase Console → Project settings → Your apps → Web uygulaması ekle → config.
 * Yerel geliştirme: .env.local veya .env.development (Vite `dev` .env.production yüklemez; kopyala: cp .env.production .env.local)
 *
 * VITE_FIREBASE_API_KEY=
 * VITE_FIREBASE_AUTH_DOMAIN=
 * VITE_FIREBASE_PROJECT_ID=
 * VITE_FIREBASE_STORAGE_BUCKET=
 * VITE_FIREBASE_MESSAGING_SENDER_ID=
 * VITE_FIREBASE_APP_ID=
 *
 * Web RSVP: Firebase Console → Authentication → Sign-in method → Anonymous açık olmalı.
 */
import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";

let app: FirebaseApp | null = null;
let db: Firestore | null = null;
let auth: Auth | null = null;

export function getFirebase(): { app: FirebaseApp; db: Firestore; auth: Auth } {
  if (app && db && auth) return { app, db, auth };

  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  if (!config.apiKey || !config.projectId) {
    throw new Error(
      "Firebase web config eksik. `npm run dev` .env.production okumaz; Website/.env.local oluştur (ör. cp .env.production .env.local) veya .env.development kullan.",
    );
  }

  app = initializeApp(config);
  db = getFirestore(app);
  auth = getAuth(app);
  return { app, db, auth };
}
